//ComplaintChatUI
export const formatChatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = date.getDate(); // 23
  const month = date.toLocaleString("en-US", { month: "short" }); // Jan

  let hours = date.getHours(); // 14
  const minutes = date.getMinutes().toString().padStart(2, "0"); // 00

  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12; // convert to 12-hour format (2)

  return `${day} ${month} ${hours}:${minutes} ${ampm}`;
};

//ComplaintChatUI
export const getComplainStatusClass = (status) => {
  switch (status?.toLowerCase()) {
    case "Opened":
    case "pending":
      return "status-pending";

    case "in_progress":
      return "status-inprogress";

    case "Resolved":
      return "status-resolved";

    case "closed":
      return "status-closed";

    case "cancel":
    case "Cancelled":
      return "status-cancelled";

    default:
      return "status-pending";
  }
};

// Voucher ScreenColor
export const getColorForVoucherType = (vouType = "") => {
  switch (vouType.toLowerCase()) {
    case "payment":
      return "#f4ccd2";
    case "contra":
      return "#d3c5e5";
    case "journal":
      return "#c4dfe6";
    case "receipt":
      return "#cadcfc";
    default:
      return "transparent";
  }
};



//single material table
// ✅ Helper: parse length safely (handles "7000" or "7000-8899")
export const parseLength = (value) => {
  if (!value) return 0;
  if (typeof value === "number") return value;
  const str = value.toString();
  if (str.includes("-")) {
    const parts = str.split("-").map(v => parseFloat(v.trim()) || 0);
    return parts[1] || parts[0]; // if range, take second value (e.g. 8899)
  }
  return parseFloat(str) || 0;
};

export const K = 0.785 / 100000; // Steel constant (kg/mm³)

// ANGLE (equal leg) -> needs t, b, L
export const calcAngleWeightKg = (length_mm, width_mm, thickness_mm) => {
  if (!length_mm || !width_mm || !thickness_mm) return 0;
  const area = thickness_mm * (2 * width_mm - thickness_mm); // mm^2
  return +(length_mm * area * K).toFixed(2);
};


// BEAM (fallback when only t is available) -> rough slab approx using L, b, t
export const calcBeamWeightKg_Approx = (length_mm, width_mm, thickness_mm) => {
  if (!length_mm || !width_mm || !thickness_mm) return 0;
  const area = width_mm * thickness_mm; // mm^2 (slab)
  return +(length_mm * area * K).toFixed(2);
};

// BEAM (rectangular envelope) -> needs L, b, h (more realistic)
export const calcBeamWeightKg_Rect = (length_mm, width_mm, height_mm) => {
  if (!length_mm || !width_mm || !height_mm) return 0;
  const area = width_mm * height_mm; // mm^2
  return +(length_mm * area * K).toFixed(2);
};


export function calculateWeight(thickness, width, length, value, thick_op, leng_op, width_op) {
  const T = parseFloat(thickness) || 0;
  const W = parseFloat(width) || 0;
  const L = parseFloat(length) || 0;
  const K = parseFloat(value)

  // 👇 If flag = "yes" → use value, else use 1 (so it won’t affect multiplication)
  const tVal = thick_op === "yes" ? T : 1;
  const wVal = width_op === "yes" ? W : 1;
  const lVal = leng_op === "yes" ? L : 1;

  // ✅ Multiply only active dimensions
  const result = tVal * wVal * lVal * K;

  return +result.toFixed(2);
}

export const getMaxDate = (date1, date2) => {
  return new Date(
    Math.min(new Date(date1), new Date(date2))
  ).toISOString().split("T")[0];
};


export const allowOnlyDecimal = (e) => {
  if (!/[0-9.]/.test(e.key)) e.preventDefault();
  if (e.key === "." && e.target.value.includes(".")) e.preventDefault();
  if (e.key === "." && e.target.value.length === 0) e.preventDefault();
};

export const autoFixEmptyToZero = (e) => {
  if (e.target.value.trim() === "") {
    e.target.value = "0";
  }
};




// react select input tag  height
export const selectSizes = {
  sm: {
    control: (base) => ({ ...base, minHeight: "32px" }),
  },
  md: {
    control: (base) => ({ ...base, minHeight: "38px" }),
  },
  lg: {
    control: (base) => ({ ...base, minHeight: "45px" }),
  },
};

// po socks dropdown
export let dropdown = [
  { field_name: "Pending", field_data: "Pending" },
  { field_name: "Accepted", field_data: "Accepted" },
  { field_name: "Working in Process", field_data: "Working in Process" },
  { field_name: "Completed", field_data: "Completed" },
  { field_name: "Cancel", field_data: "Cancel" },
]


export const allowOnlyNumberAndDot = (e) => {
  const char = String.fromCharCode(e.which || e.keyCode);
  if (!/[0-9.]/.test(char)) {
    e.preventDefault();
  }
};

export const allowOnlyNumberAndDotOnPaste = (e) => {
  const paste = e.clipboardData.getData("text");
  if (!/^\d*\.?\d*$/.test(paste)) {
    e.preventDefault();
  }
};
